exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".content{flex:1;padding-bottom:2rem;margin-bottom:2rem;background-color:var(--white);border-radius:.25rem;box-shadow:0px 0px 14px 0px rgba(0,0,0,.05)}", ""]);

// exports
